'use strict';

angular.module('clientDashboardApp').service('rankingService', function ($q, $http, searchService) {

    function RankingResult() {
      this.results = {};
      this.reportParams = null;
      this.pendingResults = false;
    }

    function RankingService() {

    }
    
    RankingService.prototype.snapshotSummary = function (groupId) {
        var deferred = $q.defer();

        $http
            .get('/dashboard/rankingSummary/group/' + groupId)
            .success(function (data, status, headers, config) {
                deferred.resolve(data);
            })
            .error(function (data, status, headers, config) {
                deferred.reject('Error occurred while summary!');
            });

        return deferred.promise;
    };

    function dropMissingDateKeys(rankingData) {
      _.each(rankingData, function (value, key) {
        if (0 == value) {
          delete rankingData[key]
        }
      });
    }

    RankingService.prototype.rankingTable = function (groupId, reportParams) {        
        var deferred = $q.defer();
        reportParams.groupId = groupId;
        $http
            .get('/dashboard/rankingTable/' + reportParams.reportType+'/' + reportParams.rankingType,{
                params: reportParams
            })
            .success(function (data, status, headers, config) {
                var rankingResult = new RankingResult();
                rankingResult.results = data;
                rankingResult.reportParams = {};
                angular.copy(reportParams,rankingResult.reportParams);
                rankingResult.pendingResults = false;
                deferred.resolve(rankingResult);
            })
            .error(function (data, status, headers, config) {
                deferred.reject('Error occurred while summary!');
            });

        return deferred.promise;
    };

    RankingService.prototype.rankingsTimeline = function (groupId, reportParams) {
        var deferred = $q.defer();
        reportParams.groupId = groupId;
        $http
            .get('/dashboard/rankingTimeline/' + reportParams.reportType+'/' + reportParams.rankingType,{
                params: reportParams
            })
            .success(function (data, status, headers, config) {
                var rankingResult = new RankingResult();
                rankingResult.results = data;
                rankingResult.reportParams = {};
                dropMissingDateKeys(data.rankingByPeriod);
                angular.copy(reportParams,rankingResult.reportParams);
                rankingResult.pendingResults = false;
                deferred.resolve(rankingResult);
            })
            .error(function (data, status, headers, config) {
                deferred.reject('Error occurred while summary!');
            });

        return deferred.promise;
    };

    RankingService.prototype.localAreaReport = function (groupId, reportParams) {
        var deferred = $q.defer();
        reportParams.groupId = groupId;
        $http
            .get('/dashboard/rankingLocalAreas',{
                params: reportParams
            })
            .success(function (data, status, headers, config) {
                var rankingResult = new RankingResult();
                rankingResult.results = data;
                rankingResult.reportParams = {};
                dropMissingDateKeys(data.rankingByPeriod);
                angular.copy(reportParams,rankingResult.reportParams);
                rankingResult.pendingResults = false;
                deferred.resolve(rankingResult);
            })
            .error(function (data, status, headers, config) {
                deferred.reject('Error occurred while summary!');
            });

        return deferred.promise;
    };

    RankingService.prototype.rankingHistory = function (groupId, historyParams) {
        var deferred = $q.defer();
        historyParams.groupId = groupId;
        $http
            .get('/dashboard/rankingHistory',{
                params: historyParams
            })
            .success(function (data, status, headers, config) {
                dropMissingDateKeys(data.rankingByPeriod);
                deferred.resolve(data);
            })
            .error(function (data, status, headers, config) {
                deferred.reject('Error occurred while summary!');
            });

        return deferred.promise;
    };

    RankingResult.prototype.export = function () {
      var newExportParams;
      if (this.reportParams) {
        newExportParams = angular.copy(this.reportParams);
        newExportParams.type = "rankingsReport";
      }

      return searchService.exportResults(newExportParams);
    };


    return new RankingService();
});
